
export const baseURL =  process.env.REACT_APP_BASE_URL 

export const UrlImage = `${baseURL}/uploads/unity/`
export const ApiUrl = `${baseURL}/api/`
export const sitekey = "6LfQNwkpAAAAAEE0Ateji8rN5oBP52z_5DlXSqVB"
export const propertylist = 'properties'
export const propertysimilarlist = 'properties/similar'
export const subamenities = 'sub-amenities/parentAmenity'
export const bookingsend = 'booking/send'
export const visitsend = 'visit-requests-send'
export const rentalsend = 'rental-requests-send'

